import React from 'react';
import './NavTabs.css';
import { FaUserNurse, FaProcedures, FaPills, FaCreditCard, FaUserShield } from 'react-icons/fa';

const tabsConfig = [
  { id: 'OUTPATIENT', label: 'Outpatient', icon: <FaUserNurse className="tab-icon" /> },
  { id: 'INPATIENT', label: 'Inpatient', icon: <FaProcedures className="tab-icon" /> },
  { id: 'PHARMACY', label: 'Pharmacy', icon: <FaPills className="tab-icon" /> },
  { id: 'CENTRAL BILLING', label: 'Central Billing', icon: <FaCreditCard className="tab-icon" /> },
  { id: 'ADMINISTRATION', label: 'Administration', icon: <FaUserShield className="tab-icon" /> },
];

const NavTabs = ({ activeTab, onTabClick }) => {
  return (
    <div className="nav-tabs-wrapper">
      <nav className="nav-tabs">
        {tabsConfig.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              className={`module-nav-tab ${isActive ? 'active-module' : ''}`}
              onClick={() => onTabClick(tab.id)}
            >
              {tab.icon}
              <span>{tab.label}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default NavTabs;
